import FacebookTableHeader from './FacebookTableHeader';

export default FacebookTableHeader;
